export default __webpack_public_path__ + "static/media/m2-event-image.8bead35d.png";